import { useState } from "react";

import OutsideClickComponent from "../../../../fragments/OutsideClickComponent";
import NegotiationEntirySearchAndSetItem from "./NegotiationEntirySearchAndSetItem";
import NegotiatorsControls from "./NegotiatorsControls";
import SimpleBoxDisplay from "../../../../common/SimpleBoxDisplay";

import classes from './NegotiationEntirySearchAndSet.module.css'

export default function NegotiationEntirySearchAndSet({primaryAttorney, entityType, rep, sendIsLoading, hasValue, hasLabel, negociator, contact, userPermissionEdit}) {
    const [groupDataState, setGroupDataState] = useState(null)
    const [openDrawer, setOpenDrawer] = useState(false)
    const clickHandler = async () => {
        if (userPermissionEdit) {
            setOpenDrawer(true)
            if (primaryAttorney.all_reps[rep] && primaryAttorney.all_reps[rep].length) {
                setGroupDataState(primaryAttorney.all_reps[rep])
            }
        }
        
    }

    const clearAndClose = () => {
        setOpenDrawer(false)
        setGroupDataState(null)
    }

    return <>
        <div className={classes.select_container}>
            <div style={{position: 'relative'}}>
                <SimpleBoxDisplay label={hasLabel ? hasLabel : 'Search'} value={hasValue} minWidth={250} action={clickHandler} isLoading={sendIsLoading} contact_info={contact}/>
                {openDrawer && <OutsideClickComponent task={clearAndClose}>
                    <div className={`${classes.searched_options} search_options_global`}>
                        {groupDataState && groupDataState.map(item => (
                            <NegotiationEntirySearchAndSetItem key={item.id} item={item} data={primaryAttorney} entityType={entityType} action={clearAndClose} folder={'attorneys'}/>
                        ))}
                        {!groupDataState && <div className={classes.searched_option_empty}><i className="ti ti-exclamation-circle"></i>No items found!</div>}
                    </div>    
                </OutsideClickComponent>}
            </div>    
            {entityType == 'App\\Models\\Negotiator' && userPermissionEdit && <NegotiatorsControls primaryAttorney={primaryAttorney} thereIsANegotiator={negociator}/>}      
        </div>
    </>
   
}